import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CreateProjectRequest, Project } from '@seo/types';
import { apiPost } from '@/lib/api';

export function useCreateProject() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateProjectRequest) => apiPost<Project>('/v1/projects', input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['projects'] });
    },
  });
}
